<template>
    <div class="l-inner">
        <app-section
            :title="page.title"
            :desc="page.desc"
            :push="page.push"
            bgIntro="dark"
            :bgs="Math.floor(page.cards.length/5)"
        >
            <template #content>
                <div class="p-places__grid | l-grid">
                    <card-place
                        v-for="(card, i) in page.cards"
                        :key="`card-${i}`"
                        :bg="card.bg"
                        :logo="card.logo"
                        :title="card.title"
                        :graph="{ title: card.graph_title, desc: card.graph_desc, svg: card.graph_svg }"
                        :website="card.website"
                        :facebook="card.facebook"
                        class="l-grid__item"
                    />
                </div>
            </template>
        </app-section>
        <about />
        <push :page="page.page_push" />
    </div>
</template>

<script>

import Push from 'layout/Push';
import About from 'layout/About';
import AppSection from 'layout/AppSection';
import Icon from 'objects/Icon';
import AnimText from 'objects/AnimText';
import CardPlace from 'objects/CardPlace';

export default {
    name: 'Places',
    components: {
        Push,
        About,
        AppSection,
        Icon,
        AnimText,
        CardPlace,
    },
    props: {
        page: Object,
    },
};
</script>

<style lang="scss">

.p-places__grid {

    & ~ .l-section__bg {
        background-color: $color-bright;
    }

    @media #{$breakpoint-vertical} {
        justify-content: space-around;
    }

    @media (min-width: #{2 * $card-max-width}) {

        .c-card {

            &:first-child {
                margin-top: 0;
            }

            &:nth-child(n+3) {
                margin-top: 1em;
            }
        }
    }

    @media #{$breakpoint-horizontal} {
        align-items: flex-start;

        & ~ .l-section__bg {
            width: 10%;

            &:nth-child(2) { left: 10%; }
            &:nth-child(3) { left: 33%; }
            &:nth-child(4) { left: 56%; }
            &:nth-child(5) { left: 79%; }
        }


        .c-card {
            margin-bottom: 0;

            &:nth-child(n+3) {
                margin-top: 0;
            }

            &:nth-child(5n+2),
            &:nth-child(5n+4) {
                align-self: flex-end;
            }

            &:nth-child(5n),
            &:nth-child(5n+2),
            &:nth-child(5n+4) {
                margin-right: 8vw;
            }

            &:nth-child(5n+3) {

                .c-card__corner {
                    background-color: $color-dark;
                }
            }

            &:nth-child(5n+4) {

                .c-card__corner {
                    background-color: $color-light;
                }
            }

            &:last-child {
                margin-right: 0;
            }
        }
    }
}

</style>
